namespace TabAurous.Sales {
    export namespace TopCollectionsService {
        export const baseUrl = 'Sales/TopCollections';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<SalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Sales/TopCollections/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>TopCollectionsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
